import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import '../css/Skills.css'
import '../css/Common-style.css'
import '../css/Animation.css'

import web_skill from '../images/web_skill_clbg-min.png'
import pro_skill_1 from '../images/pro_skill_4_clbg.png'

const Skills = ()=>{
    return(
        <section className="skills-sec" id="Skills">
           <h1 data-aos="fade-right" className="skill-heading title text-center">SKILLS</h1>

           <div className="container-fluid skill">
                <div data-aos-delay='1000' className="row skill-row">
                    <div data-aos="zoom-in-left" data-aos-duration="2000" className="col-md-6">
                        <img src={web_skill} className="img-fluid web-skill" alt=""/>
                    </div>
                    <div data-aos="zoom-in-right" data-aos-duration="2000" className="col-md-6">
                        <img src={pro_skill_1} className="img-fluid pro-skill" alt=""/>
                    </div>
                </div>
           </div>
        </section>
       
    );
}

export default Skills;